import { FC } from 'react';
import { Bar } from 'react-chartjs-2';
import { ChartData, ChartOptions } from 'chart.js';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Spin } from 'antd';
import { getSavingsHistory } from './apiCall';
import { useCustomQuery } from 'hooks/useCustomQuery';
import { getTokenDetails } from 'functions/userSession';
import { decodeToken } from 'react-jwt';
import { TokenType } from 'types/jwt';

interface Props {
  customerId: string | undefined;
}

// Register required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SavingsBarChart: FC<Props> = () => {
  const token = getTokenDetails();
  const decodedToken = decodeToken<TokenType>(token!);
  const customerId = decodedToken?.customerId;
  const {
    data: savingsHistory,
    isLoading,
    isError,
  } = useCustomQuery(
    ['savingsHistory'], // query key
    () => getSavingsHistory(customerId),
    { enabled: !!customerId }
  );
  const chartData: ChartData<'bar'> = {
    labels: savingsHistory?.map((item) => item.goalName),
    datasets: [
      {
        label: 'Amount Saved',
        data: savingsHistory?.map((item) => item.balance) ?? [],
        backgroundColor: '#31005C',
        borderColor: '#31005C',
        borderWidth: 1,
      },
    ],
  };

  const chartOptions: ChartOptions<'bar'> = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
        text: '',
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="px-6 py-3 bg-white rounded-lg shadow-md">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Savings History</h3>
        <button className="px-3 py-1 text-gray-600 rounded-md border">
          This Month
        </button>
      </div>
      {/* </div> */}
      <div className="min-h-[200px]">
        {isLoading ? (
          <div className="mt-4 flex justify-center">
            <Spin />
          </div>
        ) : isError ? (
          <p className="mt-4 text-sm text-red-500">
            Unable to load savings history. Please try again.
          </p>
        ) : savingsHistory && savingsHistory?.length > 0 ? (
          <div className="mt-4">
            <Bar data={chartData} options={chartOptions} />
          </div>
        ) : (
          <p className="mt-4 text-sm text-gray-500">
            No savings history available.
          </p>
        )}
      </div>
    </div>
  );
};

export default SavingsBarChart;
